// extracted by mini-css-extract-plugin
export default {"career-page":"CareerPage_career-page__ydDKB"};